// @ vendors
const PropTypes = require('prop-types');
const React = require('react');
import { connect } from 'react-redux';
//@components
const { LoadingSection } = require('commonsComponents/loadingSection');
const ShippingAddress = require('components/commons/shippingAddress/shippingAddress');
const shippingAddressAction = require('actions/shippingAddress');
const hireContactDataActions = require('actions/hireContactData');
// @actions
import { setWizardButtonStateByButton } from 'actions/okWizard';
// @utils
const { recordPage } = require('../../../utilities/tagging');
// @constants
const {
    NEW_SHIPPING_ADDRESS,
} = require('constants/shippingAddress');
const { ES_COUNTRY } = require('constants/flagBasedFeatures');
const { analyticsId, catalogue } = require('../analytics/hireSolidarityCardAnalytics');

class HireSolidarityShippingAdress extends React.Component {

    handleNextButtonStatus() {
        const {
            immShippingAddressList,
            immFlagBasedFeatures,
        } = this.props;
        const isShippingAddressButtonDisabled = !immShippingAddressList.get('shippingAddressType') && immFlagBasedFeatures.get(ES_COUNTRY);
        this.props.localSetWizardButtonStateByButton('next', {
            loading: false,
            disabled: isShippingAddressButtonDisabled,
        });
    }

    componentDidMount () {
        this.props.onSetAsCurrentStep(this.validate);
        this.handleNextButtonStatus();
        recordPage(catalogue[analyticsId.SOLIDARITY_CARD_STEP_4_VIEW]({ productName: this.props.processDetail }));
    }

    componentDidUpdate(prevProps) {
        const { immShippingAddressList } = this.props;
        const isTypeChanged = prevProps.immShippingAddressList.get('shippingAddressType') !== immShippingAddressList.get('shippingAddressType');
        (isTypeChanged) && this.handleNextButtonStatus();
    }

    validate = () => {
        const { localValidateStep, localSetShippingAddress, immHireContactData, immShippingAddressList } = this.props;
        const shippingAddressType = immShippingAddressList.get('shippingAddressType');
        let allComponentsAreValid =  true;

        if(shippingAddressType === NEW_SHIPPING_ADDRESS) {
            //Send param false in validateStep to show absence of mobile field
            localValidateStep(false);
            allComponentsAreValid = immHireContactData.get('isValid')
            //Set shipping address as new correspondance address
            allComponentsAreValid && (localSetShippingAddress(NEW_SHIPPING_ADDRESS, immHireContactData));
        }
        return {
            isValid: allComponentsAreValid,
        }
    }

    render() {
        const { immHireContactData, immShippingAddressList, setShippingAddress } = this.props;
        const isShippingAddressFeatching = immShippingAddressList.get('shippingAddressList');
        let shippingAddressBlock = <LoadingSection />;
        if(!!isShippingAddressFeatching) {
            shippingAddressBlock = (
                <ShippingAddress
                    immHireContactData={immHireContactData}
                    immShippingAddressList={immShippingAddressList}
                    setShippingAddress={setShippingAddress}
                />
            )
        }
        return (
            <article className="row hire-card-minicard-step-three">
                <div className="col-sm-12">
                    {shippingAddressBlock}
                </div>
            </article>
        );
    }
}

HireSolidarityShippingAdress.propTypes = {
    immHireContactData: PropTypes.object.isRequired,
    immShippingAddressList: PropTypes.object,
    immFlagBasedFeatures: PropTypes.object,
    localSetShippingAddress: PropTypes.func,
    localSetWizardButtonStateByButton: PropTypes.func,
    localValidateStep:  PropTypes.func,
    onSetAsCurrentStep: PropTypes.func.isRequired,
    setShippingAddress: PropTypes.func,
    processDetail: PropTypes.string,
};

module.exports.HireSolidarityShippingAdress = connect(
    state => ({
        immAccounts: state.accounts,
        immFlagBasedFeatures: state.flagBasedFeatures,
        currentStep: state.okWizard.get('currentStep'),
        error: state.okWizard.get('error'),
    }),
    {
       localSetShippingAddress: shippingAddressAction.setShippingAddress,
       localValidateStep: hireContactDataActions.validateStep,
       localSetWizardButtonStateByButton: setWizardButtonStateByButton,
    }
)(HireSolidarityShippingAdress);